/* eslint-disable @typescript-eslint/no-explicit-any */
import { styled } from 'twin.macro'
import TextareaAutosize from 'react-autosize-textarea'

import {
  inputErrorStyles,
  inputStyles,
  inputWrapperErrorStyles,
  inputWrapperStyles,
} from '../sharedStyles'

type StyledProps = {
  $hasError?: any
}

export const TextareaWrapper = styled.div(({ $hasError }: StyledProps) => [
  ...inputWrapperStyles,
  $hasError && inputWrapperErrorStyles,
])

export const StyledTextarea = styled(TextareaAutosize)(
  ({ $hasError }: StyledProps) => [inputStyles, $hasError && inputErrorStyles],
)
